import { CLAIMS_DOMAIN } from '../constants';

export function onStoreActorLoaded(state, { payload, meta }) {
  const { claimId } = meta;
  const { value } = payload;

  return state.setIn([CLAIMS_DOMAIN.STORES_ACTOR, claimId], value);
}
